module.exports = __webpack_public_path__ + "assets/img/label.36c7e5ba.png";